import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import API from '../apiConfig';

function Posts({ isLoggedIn }) {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newPost, setNewPost] = useState({ title: '', content: '' });
  const [error, setError] = useState(null);

  const fetchPosts = useCallback(async () => {
    try {
      const response = await axios.get(API.posts.fetchAll(page));
      const newPosts = response.data.posts || []; // Provide a default empty array
      if (newPosts.length === 0) {
        setHasMore(false);
      } else {
        setPosts(prevPosts => [...prevPosts, ...newPosts]);
      }
    } catch (error) {
      console.error('Error fetching posts:', error);
      setError('Failed to fetch posts. Please try again later.');
    }
  }, [page]);

  useEffect(() => {
    fetchPosts();
  }, [fetchPosts]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPost({ ...newPost, [name]: value });
  };

  const createPost = async (e) => {
    e.preventDefault();
    if (!isLoggedIn) return;
    try {
      const token = localStorage.getItem('token');
      await axios.post(API.posts.create, newPost, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setNewPost({ title: '', content: '' });
      setShowCreateForm(false);
      fetchPosts(); // Refresh the posts after creating
    } catch (error) {
      console.error('Error creating post:', error);
    }
  };

  const updatePost = async (postId, postData) => {
    if (!isLoggedIn) return;
    try {
      await axios.put(`${API.posts.update}/${postId}`, postData);
      fetchPosts(); // Refresh the posts after updating
    } catch (error) {
      console.error('Error updating post:', error);
    }
  };

  const deletePost = async (postId) => {
    if (!isLoggedIn) return;
    try {
      await axios.delete(API.posts.delete(postId));
      setPosts(posts.filter(post => post.id !== postId));
    } catch (error) {
      console.error('Error deleting post:', error);
    }
  };

  return (
    <div>
      <h2 className="text-center mb-4">All Posts</h2>
      {isLoggedIn && (
        <div className="mb-4">
          {!showCreateForm ? (
            <button className="btn btn-success" onClick={() => setShowCreateForm(true)}>
              Create New Post
            </button>
          ) : (
            <form onSubmit={createPost}>
              <div className="mb-3">
                <label htmlFor="title" className="form-label">Title</label>
                <input
                  type="text"
                  className="form-control"
                  id="title"
                  name="title"
                  value={newPost.title}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="content" className="form-label">Content</label>
                <textarea
                  className="form-control"
                  id="content"
                  name="content"
                  value={newPost.content}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary me-2">Create Post</button>
              <button type="button" className="btn btn-secondary" onClick={() => setShowCreateForm(false)}>Cancel</button>
            </form>
          )}
        </div>
      )}
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
        {posts.map(post => (
          <div key={post.id} className="col">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title">{post.title}</h5>
                <p className="card-text">{post.content.substring(0, 100)}...</p>
                {isLoggedIn && (
                  <div>
                    <button className="btn btn-primary btn-sm me-2" onClick={() => updatePost(post.id, { ...post, title: 'Updated Title' })}>
                      Update
                    </button>
                    <button className="btn btn-danger btn-sm" onClick={() => deletePost(post.id)}>
                      Delete
                    </button>
                  </div>
                )}
              </div>
              <div className="card-footer text-muted">
                Posted on: {new Date(post.createdAt).toLocaleDateString()}
              </div>
            </div>
          </div>
        ))}
      </div>
      {hasMore && (
        <div className="text-center mt-4">
          <button className="btn btn-primary" onClick={() => setPage(prevPage => prevPage + 1)}>
            Load More
          </button>
        </div>
      )}
    </div>
  );
}

export default Posts;
